var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"disabled":_vm.items.length < 1,"items":_vm.items,"item-text":"description","label":_vm.label,"return-object":"","value":_vm.modelValue},on:{"change":_vm.select}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }